import React from 'react';
import { Box, Stack, Typography } from '@mui/material';
import JSEditableInput from '@shared/ui/common/JSEditableInput';

interface DurationRowProps {
  label: string;
  value?: number;
  onChange: (value?: number) => void;
  placeholder?: string;
  suffix?: string;
}

const DurationRow: React.FC<DurationRowProps> = ({
  label,
  value,
  onChange,
  placeholder = "0",
  suffix = "days"
}) => {
  return (
    <Stack direction="row" gap={1} alignItems="center" justifyContent="flex-start" flex={1} sx={{ px: 3, height: 40 }}>
      <Typography variant="body2" sx={{ flex: 1, minWidth: '200px' }}>
        {label}
      </Typography>
      <JSEditableInput
        outlined
        value={value}
        onValueChange={(value) => onChange(value ? Number(value) : undefined)}
        placeholder={placeholder}
        suffix={suffix}
        sx={{ textAlign: 'right' }}
      />
    </Stack>
  );
};

export default DurationRow;
